// extracted by mini-css-extract-plugin
export default {"imgBox":"ImgHolder_imgBox__ARZMd","delBtn":"ImgHolder_delBtn__YYt9G"};